import {
  getMaximizeBtn,
  getMinimizeBtn,
  getWidgetContent,
  getGreetingElement,
  getMessagesElement,
  getUserMsgInputField,
  getRequestId,
  getFirstNameInput,
  getMinMaxButtonContainer,
  getCloseBtn,
} from '@/components/chatbot/chatbotElementUtils';
import { autoScrollToBottom } from '@/components/chatbot/chatbotButtonsAndFormsController';
import {
  setMinimization,
  setMaximization,
  setGreetingView,
} from '@/components/chatbot/chatbotConversationPersitenceUtils';

function minimizeContainer() {
  const minimizeBtn = getMinimizeBtn();
  const maximizeBtn = getMaximizeBtn();
  const widgetContent = getWidgetContent();
  const minMaxButtonContainer = getMinMaxButtonContainer();

  minMaxButtonContainer.classList.add('solv-chatbot-widget--minimized');
  minMaxButtonContainer.classList.remove('solv-chatbot-widget--maximized');

  minimizeBtn.classList.add('solv-chatbot-widget--hidden');
  minimizeBtn.ariaHidden = true;

  maximizeBtn.classList.remove('solv-chatbot-widget--hidden');
  maximizeBtn.ariaHidden = false;

  widgetContent.classList.add('solv-chatbot-widget--hidden');

  widgetContent.ariaHidden = true;

  setMinimization();
  trackConversationMinimization();
}

function maximizeContainer() {
  const minimizeBtn = getMinimizeBtn();
  const maximizeBtn = getMaximizeBtn();
  const widgetContent = getWidgetContent();
  const minMaxButtonContainer = getMinMaxButtonContainer();

  setMaximization();

  minMaxButtonContainer.classList.remove('solv-chatbot-widget--minimized');
  minMaxButtonContainer.classList.add('solv-chatbot-widget--maximized');

  minimizeBtn.classList.remove('solv-chatbot-widget--hidden');
  minimizeBtn.ariaHidden = false;

  maximizeBtn.classList.add('solv-chatbot-widget--hidden');
  maximizeBtn.ariaHidden = true;

  widgetContent.classList.remove('solv-chatbot-widget--hidden');
  widgetContent.ariaHidden = false;
}

function setUpMinimizeButton() {
  const minimizeBtn = getMinimizeBtn();
  minimizeBtn.addEventListener('click', (e) => {
    minimizeContainer();
  });
  const closeBtn = getCloseBtn();
  closeBtn.addEventListener('click', (e) => {
    minimizeContainer();
  });
}

function setUpMaximizeButton() {
  const maximizeBtn = getMaximizeBtn();
  maximizeBtn.addEventListener('click', (e) => {
    const greeting = getGreetingElement();
    if (greeting) {
      removeGreetingElement();
    }
    maximizeContainer();
    const userInputField = getUserMsgInputField();
    const firstNameInput = getFirstNameInput();
    // CHECK FOR MOBILE WIDTH
    const mobileWidth = window.matchMedia('(max-width: 767px)');
    if (mobileWidth.matches) {
      // do nothing
    } else if (firstNameInput) {
      firstNameInput.focus();
    } else if (userInputField) {
      userInputField.focus();
      autoScrollToBottom();
    }
  });
}

function showMessagesTemplate() {
  const messages = getMessagesElement();
  messages.classList.remove('solv-chatbot-widget__messages--hidden');
  messages.ariaHidden = false;
}

function removeGreetingElement() {
  const greeting = getGreetingElement();
  greeting.remove();

  const widgetContent = getWidgetContent();
  widgetContent.classList.remove('uninitialized');

  // unhide the messages element which is hidden behind the greeting element
  showMessagesTemplate();

  // send message to the backend that the user has started the chat for analytics purposes
  trackConversationInitiation();
}

async function trackConversationInitiation() {
  // send message to the backend that the user has started the chat for analytics purposes
  const requestId = getRequestId();
  const testURLElement = document.getElementById('testing-chatbot-locally');
  let messageURL =
    'https://www.solvhealth.com/dir/chatbot-conversation-started';
  if (testURLElement) {
    messageURL = '/dir/chatbot-conversation-started';
  }
  const data = {
    request_id: requestId,
  };
  await fetch(messageURL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
}

async function trackConversationMinimization() {
  // send message to the backend that the user has started the chat for analytics purposes
  const requestId = getRequestId();
  const testURLElement = document.getElementById('testing-chatbot-locally');
  let messageURL = 'https://www.solvhealth.com/dir/chatbot-conversation-closed';
  if (testURLElement) {
    messageURL = '/dir/chatbot-conversation-closed';
  }
  const data = {
    request_id: requestId,
  };
  await fetch(messageURL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
}

// change the visibility of the buttons without affecting the container
function switchMinMaxButtonVisibility() {
  const minimizeBtn = getMinimizeBtn();
  const maximizeBtn = getMaximizeBtn();

  minimizeBtn.classList.toggle('solv-chatbot-widget--hidden');
  minimizeBtn.ariaHidden = minimizeBtn.classList.contains(
    'solv-chatbot-widget--hidden',
  );

  maximizeBtn.classList.toggle('solv-chatbot-widget--hidden');
  maximizeBtn.ariaHidden = maximizeBtn.classList.contains(
    'solv-chatbot-widget--hidden',
  );
}

export {
  setUpMinimizeButton,
  setUpMaximizeButton,
  switchMinMaxButtonVisibility,
  removeGreetingElement,
  showMessagesTemplate,
  maximizeContainer,
};
